export default "__VITE_ASSET__B8TK8ziR__"